if (!customElements.get('customer-looks')) {
  customElements.define(
    'customer-looks',
    class CustomerLooks extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;

        this.track = this.querySelector(
          '[data-customer-track]'
        );

        this.modal = this.querySelector(
          '[data-customer-modal]'
        );

        this.player = this.querySelector(
          '[data-customer-player]'
        );

        this.cards = [
          ...this.querySelectorAll(
            '[data-customer-open]'
          ),
        ];

        this.templates = [
          ...this.querySelectorAll(
            '[data-customer-video-template]'
          ),
        ];

        this.previousButton = this.querySelector(
          '[data-customer-previous]'
        );

        this.nextButton = this.querySelector(
          '[data-customer-next]'
        );

        this.closeButton = this.querySelector(
          '[data-customer-close]'
        );

        this.index = 0;

        this.cards.forEach((card) => {
          card.addEventListener('click', () => {
            this.open(
              Number(card.dataset.customerOpen)
            );
          });
        });

        /*
          只有右上角 X 可以关闭。
          页面空白处不会关闭视频。
        */
        this.closeButton?.addEventListener(
          'click',
          () => this.close()
        );

        this.previousButton?.addEventListener(
          'click',
          () => this.show(this.index - 1)
        );

        this.nextButton?.addEventListener(
          'click',
          () => this.show(this.index + 1)
        );

        this.querySelectorAll(
          '[data-customer-scroll]'
        ).forEach((button) => {
          button.addEventListener('click', () => {
            const direction =
              button.dataset.customerScroll === 'next'
                ? 1
                : -1;

            this.scroll(direction);
          });
        });

        this.track?.addEventListener(
          'scroll',
          () => this.updateScrollButtons(),
          { passive: true }
        );

        this.updateScrollButtons();
      }

      scroll(direction) {
        const card = this.cards[0];

        if (!card || !this.track) return;

        const styles = getComputedStyle(this.track);

        const gap =
          parseFloat(styles.columnGap) || 0;

        const distance =
          (card.offsetWidth + gap) * 2;

        this.track.scrollBy({
          left: direction * distance,
          behavior: 'smooth',
        });
      }

      updateScrollButtons() {
        if (!this.track) return;

        const previous = this.querySelector(
          '[data-customer-scroll="previous"]'
        );

        const next = this.querySelector(
          '[data-customer-scroll="next"]'
        );

        if (previous) {
          previous.disabled =
            this.track.scrollLeft <= 2;
        }

        if (next) {
          next.disabled =
            this.track.scrollLeft +
              this.track.clientWidth >=
            this.track.scrollWidth - 2;
        }
      }

      open(index) {
        if (!this.modal) return;

        this.lastFocused =
          document.activeElement;

        this.modal.hidden = false;

        /*
          保留这个 class，但 CSS 不再锁定页面滚动。
        */
        document.body.classList.add(
          'customer-looks-modal-open'
        );

        this.show(index);
      }

      show(index) {
        if (!this.templates.length) return;

        this.index =
          (index + this.templates.length) %
          this.templates.length;

        const template =
          this.templates[this.index];

        this.player.replaceChildren(
          template.content.cloneNode(true)
        );

        const video =
          this.player.querySelector('video');

        if (video) {
          /*
            打开视频后才加载。
            默认关闭声音。
          */
          video.preload = 'metadata';
          video.muted = true;
          video.defaultMuted = true;
          video.volume = 1;

          video.setAttribute('muted', '');
          video.setAttribute(
            'playsinline',
            ''
          );

          video.play().catch(() => {
            /*
              如果浏览器阻止自动播放，
              顾客仍然可以点击播放器手动播放。
            */
          });
        }

        const hideArrows =
          this.templates.length < 2;

        if (this.previousButton) {
          this.previousButton.hidden =
            hideArrows;
        }

        if (this.nextButton) {
          this.nextButton.hidden =
            hideArrows;
        }
      }

      close() {
        const video =
          this.player?.querySelector('video');

        if (video) {
          video.pause();
          video.removeAttribute('src');

          video
            .querySelectorAll('source')
            .forEach((source) => {
              source.removeAttribute('src');
            });

          video.load();
        }

        this.player?.replaceChildren();

        if (this.modal) {
          this.modal.hidden = true;
        }

        document.body.classList.remove(
          'customer-looks-modal-open'
        );

        this.lastFocused?.focus?.();
      }
    }
  );
}